var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateBroadcast = function SvgCreateBroadcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient);\n        opacity: .25;\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 136.53,
    y1: 48.16,
    x2: 41.68,
    y2: 165.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 185.27,
    y1: 27.3,
    x2: 78.09,
    y2: 203.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 128.85,
    y1: -6.97,
    x2: 21.67,
    y2: 169.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 153.65,
    y1: 8.09,
    x2: 46.47,
    y2: 184.58,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 152.24,
    y1: 7.24,
    x2: 45.06,
    y2: 183.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 152.28,
    y1: 7.26,
    x2: 45.1,
    y2: 183.75,
    xlinkHref: "#linear-gradient-2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 100,
    cy: 93.33,
    r: 76.04
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_09-Broadcast",
    "data-name": " 09-Broadcast"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.8,175.47l3.82,10,3.82,10c.2.52.26,1.06.2,1.6s-.25,1.05-.57,1.5c-.31.45-.72.81-1.19,1.05s-1,.38-1.54.38H56.66c-.55,0-1.07-.14-1.54-.38s-.88-.6-1.19-1.05c-.31-.45-.51-.97-.57-1.5s0-1.08.2-1.6l18.88-49.4,18.88-49.4c-1.46-1.25-2.62-2.79-3.42-4.49-.8-1.71-1.23-3.58-1.25-5.51,0-3.68,1.49-7.02,3.91-9.43,2.41-2.41,5.75-3.91,9.43-3.91s7.02,1.49,9.43,3.91c2.41,2.41,3.91,5.75,3.91,9.43-.02,1.93-.45,3.8-1.25,5.51-.8,1.71-1.95,3.24-3.42,4.49l12.52,32.68,12.52,32.68c.33.86.28,1.76-.06,2.54-.34.78-.98,1.42-1.84,1.76-.19.08-.39.14-.59.18s-.41.06-.61.06c-.69,0-1.34-.21-1.88-.59s-.97-.9-1.22-1.55l-1.82-4.72-1.82-4.72-8.97,6.08-8.97,6.08,15.25,10.35,15.25,10.35-1.92-5-1.92-5c-.04-.07-.07-.15-.1-.23s-.06-.15-.08-.23c-.27-.88-.15-1.79.25-2.54s1.09-1.35,1.97-1.62,1.79-.15,2.54.25c.75.4,1.35,1.09,1.62,1.97ZM132.46,193.33l-16.23-11.02-16.23-11.02-16.23,11.02-16.23,11.02h64.93ZM76.13,155.1l-6.28,16.43-6.28,16.43,15.25-10.35,15.25-10.35-8.97-6.08-8.97-6.08ZM100,163.33l10-6.77,10-6.77-10-8.6-10-8.6-10,8.6-10,8.6,10,6.77,10,6.77ZM82.33,139.03l6.28-5.42,6.28-5.42-3.18-2.72-3.18-2.72-3.1,8.13-3.1,8.13ZM105.1,128.2l6.3,5.42,6.3,5.42-3.12-8.13-3.12-8.13-3.18,2.72-3.18,2.72ZM100,80c-1.84,0-3.51.75-4.71,1.95-1.21,1.21-1.95,2.87-1.95,4.71s.75,3.51,1.95,4.71,2.87,1.95,4.71,1.95,3.51-.75,4.71-1.95c1.21-1.21,1.95-2.87,1.95-4.71s-.75-3.51-1.95-4.71c-1.21-1.21-2.87-1.95-4.71-1.95ZM100,100h0s0,0,0,0c-.45,0-.91-.02-1.36-.07s-.9-.11-1.34-.2l-3.12,8.15-3.12,8.15,4.47,3.83,4.47,3.83,4.47-3.83,4.47-3.83-3.12-8.15-3.12-8.15c-.44.09-.89.15-1.34.2s-.9.07-1.36.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.7,69.8h0c.75.53,1.22,1.31,1.37,2.14s-.02,1.73-.54,2.49c-3.58,5.21-5.53,11.21-5.82,17.3-.29,6.08,1.09,12.24,4.16,17.77.45.8.53,1.71.3,2.53-.23.82-.77,1.55-1.57,2-.25.14-.51.25-.79.32s-.56.11-.84.11c-.6,0-1.18-.16-1.68-.46-.5-.29-.93-.72-1.22-1.24-3.7-6.64-5.35-14.04-5.01-21.35.35-7.31,2.7-14.52,7.01-20.78.53-.75,1.31-1.22,2.14-1.37s1.73.02,2.49.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.4,114.03h0c-.8-.45-1.34-1.18-1.57-2s-.15-1.73.3-2.53c3.06-5.53,4.43-11.68,4.14-17.76-.29-6.08-2.24-12.07-5.82-17.28-5.21-7.59-13.01-12.34-21.4-13.89s-17.37.09-24.95,5.3c-.73.45-1.56.59-2.35.45s-1.52-.56-2.04-1.24c-.56-.73-.78-1.61-.67-2.46.11-.85.54-1.65,1.26-2.22,6.25-4.29,13.45-6.64,20.74-6.99,7.29-.35,14.68,1.29,21.31,4.97,9.66,5.36,16.23,14.12,19.05,23.96,2.82,9.84,1.89,20.76-3.47,30.42-.29.52-.72.95-1.22,1.24s-1.08.46-1.68.46c-.29,0-.57-.04-.84-.11s-.54-.18-.79-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143,143.1c-.47,0-.94-.09-1.36-.28s-.81-.46-1.13-.81c-.62-.68-.9-1.55-.86-2.4.04-.85.41-1.69,1.09-2.31,6.17-5.64,11-12.46,14.28-19.95s5.02-15.66,4.99-24.02c0-16.56-6.72-31.55-17.57-42.41-10.85-10.85-25.85-17.57-42.41-17.57-16.57,0-31.57,6.71-42.43,17.56-10.86,10.85-17.58,25.85-17.59,42.42-.03,8.36,1.7,16.53,4.99,24.02,3.28,7.49,8.11,14.3,14.28,19.95.67.62,1.03,1.46,1.07,2.31.04.85-.25,1.71-.87,2.39,0,0,0,0-.01.01s0,0-.01.01c-.63.67-1.47,1.03-2.32,1.06s-1.72-.26-2.39-.89c-.64-.59-1.26-1.19-1.87-1.8s-1.21-1.24-1.8-1.87c-12.5-13.52-18.34-30.82-17.67-47.87.67-17.05,7.83-33.84,21.35-46.34,13.52-12.5,30.82-18.34,47.87-17.67,17.05.67,33.84,7.83,46.34,21.35,12.5,13.52,18.34,30.82,17.67,47.87-.67,17.05-7.83,33.84-21.35,46.34-.31.29-.66.51-1.05.66s-.8.23-1.22.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100,0h0c14.9,0,29.36,3.56,42.29,10.13,12.93,6.57,24.32,16.15,33.11,28.19,15.19,20.82,20.5,45.83,16.81,69.43-3.69,23.6-16.38,45.79-37.2,60.98-.29.21-.6.37-.93.47s-.68.16-1.03.16c-.54,0-1.06-.13-1.52-.36s-.87-.58-1.19-1.02c-.54-.75-.73-1.64-.59-2.48s.59-1.63,1.34-2.17c3.63-2.65,7.05-5.57,10.22-8.74,3.17-3.17,6.09-6.58,8.74-10.22,14.1-19.34,19.03-42.56,15.6-64.47-3.43-21.91-15.22-42.52-34.56-56.62-19.34-14.1-42.56-19.03-64.47-15.6-21.91,3.43-42.52,15.22-56.62,34.56-14.1,19.34-19.03,42.56-15.6,64.47,3.43,21.91,15.22,42.52,34.56,56.62h0c.75.54,1.2,1.34,1.33,2.18.13.84-.06,1.74-.6,2.49-.54.75-1.34,1.2-2.18,1.33s-1.74-.06-2.49-.6c-12.04-8.78-21.62-20.18-28.19-33.11-6.57-12.93-10.13-27.38-10.13-42.29,0-25.77,10.44-49.11,27.33-66C50.89,10.45,74.22,0,100,0Z"
  }))));
};
export default SvgCreateBroadcast;